import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import DatosCamara_Generales from './DatosCamara_Generales';
import DatosCamara_VotosPartidos from './DatosCamara_VotosPartidos';
import DatosCamara_Territorios from './DatosCamara_Territorios';
import { usePage } from '../../contexts/pageContext';

const DatosCamara = ({tVisible, data, color}) => {
    const t = useTranslate();
    const pageState = usePage();
    const { data:dataState } = pageState;
    const tVisiblePartido=(dataState.elec==='7' && dataState.amb==='00')?false:true;
    return(
        <div style={{borderBottom: '11px solid', borderColor:color}}>
            <DatosCamara_Generales data={data} title={t('informacionGeneral')}/>
            {tVisiblePartido && <DatosCamara_VotosPartidos data={data} title={t('votosPartidos')}/>}
            {tVisible && <DatosCamara_Territorios data={data} title={t('territorios')}/>}
        </div>
    );
};

export default DatosCamara;